// Modules
import React from 'react';
import _ from 'lodash';

import { FormCard } from 'components/content-containers/cards';
import { PageContent } from 'components/page';
import SVG from 'components/widgets/icons/svg';
import Watch from 'services/data/watch';
import WatchForm from 'components/models/company/watch-form';
import appHistory from 'app-history';

import * as actions from '../store/actions';


export default function WatchEdit({ routeParams: { watchId }, id: companyId }) {
  const { data: company } = actions.useCompany(companyId);
  const { data: watches, refetch } = actions.useCompanyWatches(companyId);
  const watch = _.find(watches, { id: Number(watchId) });

  const onSubmit = values => {
    const update = _.clone(values);

    return Watch.update(update)
      .then(() => refetch())
      .then(() => {
        appHistory.push(`/companies/${company.id}/watches`);
      });
  };

  const initialValues = _.pick(watch, ['company', 'date', 'notes', 'id']);

  if (!watch) return null;

  return (
    <PageContent className="bg-medium-blue-grey">
      <div className="form-summary flex flex-equal-children">
        <FormCard className="form-form">
          <div className="form-header">
            <SVG src="svg/growth.svg" className="growth" />
            <h5 className="form-title">Edit Watch</h5>
          </div>
          <WatchForm
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </FormCard>
      </div>
    </PageContent>
  );
}
